export default __webpack_public_path__ + "static/media/back.c3abcf6b.svg";